import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';

export const PER_PAGE = 500;

export const listAppDatasetVersionsTE = <E = CF.API.ApiError>(
  {
    appId,
    userId,
    datasetId,
    page = 1,
    perPage = PER_PAGE,
  }: {
    appId: string;
    userId: string;
    datasetId: string;
    page?: number;
    perPage?: number;
  },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Datasets.ListDatasetVersionsResponse> =>
  fetchTE<CF.API.Datasets.ListDatasetVersionsResponse, E>(
    {
      // request_origin=1 is a query parameter that ensures internal datasets are not returned
      path: `/api/_api/v2/users/${userId}/apps/${appId}/datasets/${datasetId}/versions?request_origins=1&page=${page}&per_page=${perPage}`,
      method: 'GET',
    },
    onRejected,
  );
